import 'bootstrap-daterangepicker/daterangepicker.css';
import { debounce } from 'lodash';
import moment from 'moment';
import { useCallback, useEffect, useState } from 'react';
import { FaEye } from 'react-icons/fa6';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import ReactReadMoreReadLess from "react-read-more-read-less";
import { toast } from 'react-toastify';
import { Tooltip } from 'react-tooltip';
import { KTSVG } from '../../../_metronic/helpers';
import { PageTitle } from '../../../_metronic/layout/core';
import CurrencyComp from '../../../components/currencyComponent/CurrencyComp';
import DateComp from '../../../components/dateComponent/DateComp';
import DateRangeComp from '../../../components/dateComponent/DateRangeComp';
import DateTimeComp from '../../../components/dateComponent/DateTimeComp';
import FilterMenu from '../../../components/filterMenu/FilterMenu';
import { LoadingComponent } from '../../../components/loadingComponent/LoadingComponent';
import NoRecordFound from '../../../components/noRecord/NoRecordFound';
import Pagination from '../../../components/pagination/Pagination';
import RefreshComponent from '../../../components/refreshComponent/RefreshComponent';
import SearchBarComponent from '../../../components/searchBar/SearchBarComponent';
import TableHeading from '../../../components/tableHeading/TableHeading';
import TableSettingMenu from '../../../components/tableHeading/TableSettingMenu';
import SearchSelect from '../../../components/textFields/SearchSelect';
import TextField from '../../../components/textFields/TextField';
import { constraintConfig } from '../../../constraintConfig';
import { selectAuth } from '../../../features/authSlice';
import { useAppSelector } from '../../../hooks';
import { useGetCardExpenseItemQuery, useLazyGetExpenseItemsByExpenseItemIdQuery } from '../../../services/ExpenseApi';
import { useExpenseCategoryLookupQuery, useGetAllRecordSourceLookupQuery, useGetPaymentMethodLookupQuery } from '../../../services/GeneralApi';
import useColumnVisibility from '../../customHooks/useColumnVisibility';
import labelKey from "../../localization/label.json";
import tosterKey from "../../localization/toster.json";
import AssignToExistingExpenseModal from './AssignToExistingExpenseModal';
import AssignToNewExpenseModal from './AssignToNewExpenseModal';
import CategoriesWithIcons from './CategoriesWithIcons';
import DeleteExpenseModal from './DeleteExpenseModal';
import { AddExpenseItemModal } from './update-single-Item/AddExpenseItemModal';
import SingleItemDetailModal from './update-single-Item/SingleItemDetailModal';
import { UpdateExpenseItemModal } from './update-single-Item/UpdateExpenseItemModal';
import UploadDirectReceipt from './UploadDirectReceipt';
import { Alert } from 'react-bootstrap';
import MergeExpenseModal from './MergeExpenseModal';
import UnMergeConfirmationModal from './UnMergeConfirmationModal';

interface LightboxData {
    imageURL: string;
}

const DraftItemsPage = () => {
    const { hiddenColumns, handleToggleColumn } = useColumnVisibility({ pageName: 'expenseLineItems' });
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [lightboxData, setLightboxData] = useState<LightboxData>({ imageURL: '' });
    const { userAccountID } = useAppSelector(selectAuth);
    const [page, setPage] = useState(1)
    const [pageSize, setPageSize] = useState(10);
    const [searchStr, setSearchStr] = useState(''); // debounce search
    const [immediateSearchStr, setImmediateSearchStr] = useState('');
    const [sortBy, setSortBy] = useState("itemDate");
    const [sortOrder, setSortOrder] = useState("desc");
    const [filterByCategory, setFilterByCategory] = useState("");
    const [filterByStartDate, setFilterByStartDate] = useState("");
    const [filterByEndDate, setFilterByEndDate] = useState("");
    const [filterBySubCategory, setFilterBySubCategory] = useState("");
    const [selectedExpenseItemIds, setSelectedExpenseItemIds] = useState<number[]>([]);
    const [sortedColumn, setSortedColumn] = useState("itemDate");
    const [isTableHeadChecked, setIsTableHeadChecked] = useState(false);

    const [filterByCreatedStartDate, setFilterByCreatedStartDate] = useState("")
    const [filterByCreatedEndDate, setFilterByCreatedEndDate] = useState("")
    const [filterByAmount, setFilterByAmount] = useState(0)
    const [filterByRecordSourceId, setFilterByRecordSourceId] = useState(0)
    const [filterByPaymentMethodId, setFilterByPaymentMethodId] = useState(0)

    const [localFilterByCreatedStartDate, setLocalFilterByCreatedStartDate] = useState("")
    const [localFilterByCreatedEndDate, setLocalFilterByCreatedEndDate] = useState("")
    const [localFilterByAmount, setLocalFilterByAmount] = useState(0)
    const [localFilterByRecordSourceId, setLocalFilterByRecordSourceId] = useState(0)
    const [localFilterByPaymentMethodId, setLocalFilterByPaymentMethodId] = useState(0)

    const [showUpdateExpenseModal, setShowUpdateExpenseModal] = useState(false)


    const [localFilterByStartDate, setLocalFilterByStartDate] = useState("");
    const [localFilterByEndDate, setLocalFilterByEndDate] = useState("");
    const [localFilterByCategory, setlocalFilterByCategory] = useState("");
    const [isApplyingFilters, setIsApplyingFilters] = useState(false);

    const { data: expenseCategory } = useExpenseCategoryLookupQuery('')
    const { data: paymentMethodLookup } = useGetPaymentMethodLookupQuery('')
    const { data: recordSourceLookup } = useGetAllRecordSourceLookupQuery('')

    const [showConfirmModal, setShowConfirmModal] = useState(false)
    const [selectedItem, setSelectedItem] = useState(null)
    const handleUnmergeClick = (item: any) => {
        setSelectedItem(item)
        setShowConfirmModal(true)
    }

    const [expenseItemById, { data: expenseItemByIdData, isFetching: expenseItemByIdDataFetching }] = useLazyGetExpenseItemsByExpenseItemIdQuery({})
    const { data, isFetching: isLoading, refetch, isSuccess } = useGetCardExpenseItemQuery({
        userAccountId: userAccountID,
        pageNumber: page,
        pageSize: pageSize,
        sortBy: sortBy,
        sortOrder: sortOrder,
        searchStr: searchStr,
        filterByCategory: filterByCategory,
        startDate: filterByStartDate,
        endDate: filterByEndDate,
        createdStartDate: filterByCreatedStartDate,
        createdEndDate: filterByCreatedEndDate,
        filterByAmount: filterByAmount,
        filterByRecordSourceId: filterByRecordSourceId,
        filterByPaymentMethodId: filterByPaymentMethodId
    })

    // pagination
    const handlePageClick = (e: any) => {
        setPage(e.selected + 1);
    };
    const handlePageSizeChange = (e: any) => {
        const newSize = parseInt(e.target.value);
        setPageSize(newSize);
        setPage(1); // Reset page number to 1
    };

    const handleSort = (property: string) => {
        setSortBy(property);
        if (sortedColumn === property) {
            setSortOrder(prevSortOrder => (prevSortOrder === "asc" ? "desc" : "asc"));
        } else {
            setSortedColumn(property);
            setSortOrder("asc");
        }
        // Perform additional sorting logic...
    };


    //per page record
    const handlePageRecords = (e: any) => {
        setPage(1); // Reset the page to 1
    };
    const handleSearchChange = (e: any) => {
        const { value } = e.target;
        setImmediateSearchStr(value); // Update immediate search state
        delayedSearch(value); // Update debounced search state
        setPage(1)
    };

    const delayedSearch = useCallback(
        debounce((searchValue) => {
            setSearchStr(searchValue);
        }, 500),
        []
    );
    const handleCategoryChange = (e: any) => {
        setlocalFilterByCategory(e.value);
    };
    const handlePaymentMethodChange = (e: any) => {
        setLocalFilterByPaymentMethodId(e.value);
    };
    const handleRecordSourceChange = (e: any) => {
        setLocalFilterByRecordSourceId(e.value);
    };
    const handleFilterByAmount = (e: any) => {
        setLocalFilterByAmount(e.target.value);
    };
    const handleDateRangeChange = (event: any, picker: any) => {
        const startDateFormatted = moment(picker.startDate).format('MM-DD-YYYY');
        const endDateFormatted = moment(picker.endDate).format('MM-DD-YYYY');

        setLocalFilterByStartDate(startDateFormatted);
        setLocalFilterByEndDate(endDateFormatted);
    };
    const handleCancelDateSelection = (event: any, picker: any) => {
        // Reset the state to empty strings
        setFilterByStartDate("");
        setFilterByEndDate("");
        setLocalFilterByStartDate("");
        setLocalFilterByEndDate("");
    };
    const handleCreatedDateRangeChange = (event: any, picker: any) => {
        const startDateFormatted = moment(picker.startDate).format('MM-DD-YYYY');
        const endDateFormatted = moment(picker.endDate).format('MM-DD-YYYY');

        setLocalFilterByCreatedStartDate(startDateFormatted);
        setLocalFilterByCreatedEndDate(endDateFormatted);
    };
    const handleCreatedCancelDateSelection = (event: any, picker: any) => {
        // Reset the state to empty strings
        setFilterByCreatedStartDate("");
        setFilterByCreatedEndDate("");
        setLocalFilterByCreatedStartDate("");
        setLocalFilterByCreatedEndDate("");
    };

    const applyFilters = () => {
        setIsApplyingFilters(true);
        setFilterByStartDate(localFilterByStartDate);
        setFilterByEndDate(localFilterByEndDate);
        setFilterByCategory(localFilterByCategory);

        setFilterByCreatedStartDate(localFilterByCreatedStartDate)
        setFilterByCreatedEndDate(localFilterByCreatedEndDate)
        setFilterByAmount(localFilterByAmount)
        setFilterByRecordSourceId(localFilterByRecordSourceId)
        setFilterByPaymentMethodId(localFilterByPaymentMethodId)
        setPage(1)
    };
    const resetFilters = () => {
        setFilterByStartDate('');
        setFilterByEndDate('');
        setFilterByCategory("");
        setLocalFilterByStartDate('');
        setLocalFilterByEndDate('');
        setlocalFilterByCategory('');
        setFilterByCreatedStartDate('');
        setFilterByCreatedEndDate('');
        setFilterByAmount(0);
        setFilterByRecordSourceId(0);
        setFilterByPaymentMethodId(0);
        setLocalFilterByCreatedStartDate('');
        setLocalFilterByCreatedEndDate('');
        setLocalFilterByAmount(0);
        setLocalFilterByRecordSourceId(0);
        setLocalFilterByPaymentMethodId(0);
    }
    const debouncedRefetch = debounce(() => {
        refetch().finally(() => {
            setIsApplyingFilters(false);
        });
    }, 300);
    useEffect(() => {
        if (isApplyingFilters) {
            debouncedRefetch();
        }
    }, [isApplyingFilters]);


    useEffect(() => {
        if (searchStr === "" ||
            sortOrder === "asc" ||
            sortBy === ""
        ) {
            refetch();
        }
    }, [sortOrder, sortBy, searchStr]);
    const [showAddExpenseItemModal, setShowAddExpenseItemModal] = useState(false)

    const [showExpenseItemDetailModal, setShowExpenseItemDetailModal] = useState(false)


    const [showUpdateExpenseItemModal, setShowUpdateExpenseItemModal] = useState(false)
    const [showExpenseItemData, setShowExpenseItemData] = useState({})
    const [viewOnlyData, setViewOnlyData] = useState(false)

    const expenseItemModalHandler = () => {
        setShowUpdateExpenseItemModal((prev) => !prev);
    };

    const handleTableHeadChange = (e: any) => {
        const isChecked = e.target.checked;
        // console.log(`Table head checked: ${isChecked}`); 
        setIsTableHeadChecked(isChecked);
        const allExpenseItems = data?.result?.data || [];
        // console.log('All expense items:', allExpenseItems); 

        const filteredExpenseItems = allExpenseItems.filter((item: any) => item?.paymentMethod?.id !== 3);
        // console.log('Filtered expense items:', filteredExpenseItems);
        if (isChecked) {
            const allExpenseItemIds = filteredExpenseItems.map((item: any) => item.expenseItemId);
            // console.log('Expense item IDs to be checked:', allExpenseItemIds);

            setSelectedExpenseItemIds((prevIds) => {
                const updatedIds = Array.from(new Set([...prevIds, ...allExpenseItemIds]));
                // console.log('Updated selected expense item IDs:', updatedIds);
                return updatedIds;
            });
        } else {
            setSelectedExpenseItemIds([]);
        }

        // Update isTableHeadChecked state
        //  setIsTableHeadChecked(isChecked);

        setIsTableHeadChecked(isChecked && filteredExpenseItems.length === allExpenseItems.length);

    };



    // handleCheckbox
    const handleCheckItem = (e: any, itemId: any) => {
        const isChecked = e.target.checked;

        setSelectedExpenseItemIds((prevItems) => {
            // Create a copy of the previous selectedExpenseItemIds array
            const updatedIds = [...prevItems];

            if (isChecked) {
                // If the checkbox is checked, add the itemId to the selectedExpenseItemIds array
                updatedIds.push(itemId);
            } else {
                // If the checkbox is unchecked, remove the itemId from the selectedExpenseItemIds array
                const index = updatedIds.indexOf(itemId);
                if (index !== -1) {
                    updatedIds.splice(index, 1);
                }
            }

            // Update the table head checkbox state based on the current state of the checkboxes in the body
            // setIsTableHeadChecked(updatedIds.length === data?.result?.data?.length);
            setIsTableHeadChecked(updatedIds.length === pageSize * (page - 1) + data?.result?.data?.length);

            return updatedIds;
        });
    };

    useEffect(() => {
        setIsTableHeadChecked(false); // Reset isTableHeadChecked when page changes
    }, [page]);

    const resetCheckboxState = () => {
        setIsTableHeadChecked(false);
        setSelectedExpenseItemIds([]);
    };


    // Whether any checkbox in the table body is checked
    const isAnyCheckboxChecked = selectedExpenseItemIds.length > 0 || isTableHeadChecked;

    const [showAddNewExpenseModal, setShowAddNewExpenseModal] = useState(false)
    const addNewExpenseModalHandler = () => {
        setShowAddNewExpenseModal((prev) => !prev);
    };

    const [showAddExistingExpensetModal, setShowAddExistingExpenseModal] = useState(false)
    const eidtProjectModalHandler = () => {
        setShowAddExistingExpenseModal((prev) => !prev);
    };

    const [showExpenseDeleteModal, setShowExpenseDeleteModal] = useState(false)
    const [expenseDeleteData, setExpenseDeleteData] = useState({});

    const deleteHandler = () => {
        setShowExpenseDeleteModal((prev) => !prev);
    };

    const isPdfFile = (filePath: string | undefined) => {
        if (!filePath) return false;
        const fileExtension = filePath.toLowerCase().split('.').pop();
        return fileExtension === 'pdf';
    };
    const openPdfInBrowserOrLightbox = (attachmentFile: string | undefined) => {
        if (attachmentFile) {
            if (isPdfFile(attachmentFile)) {
                // For PDF files, open in the browser
                window.open(attachmentFile, '_blank');
            } else {
                // For image files, open in the Lightbox
                setLightboxData({ imageURL: attachmentFile });
                setLightboxOpen(true);
            }
        }
    };

    const handleRefresh = () => {
        resetCheckboxState();
        refetch()
            .then(() => {
                if (isSuccess) {
                    toast.success(tosterKey.dataRefreshedSuccesfully);
                }
            });
    };
    return (
        <>
            <AddExpenseItemModal
                show={showAddExpenseItemModal}
                handleClose={() => setShowAddExpenseItemModal(false)}
                viewOnlyData={false}
                refetch={refetch} />
            <UpdateExpenseItemModal
                show={showUpdateExpenseItemModal}
                handleClose={() => setShowUpdateExpenseItemModal(false)}
                // data={showExpenseItemData}
                data={expenseItemByIdData?.result}
                viewOnlyData={viewOnlyData}
                refetch={refetch} />
            <SingleItemDetailModal
                show={showExpenseItemDetailModal}
                handleClose={() => setShowExpenseItemDetailModal(false)}
                data={expenseItemByIdData?.result}
                viewOnlyData={viewOnlyData}
                isFetching={expenseItemByIdDataFetching} />
            <AssignToNewExpenseModal
                show={showAddNewExpenseModal}
                handleClose={() => {
                    setShowAddNewExpenseModal(false);
                    resetCheckboxState();
                }}
                selectedExpenseItemIds={selectedExpenseItemIds}
                refetchDraftItems={refetch}
            />
            <AssignToExistingExpenseModal
                show={showAddExistingExpensetModal}
                handleClose={() => {
                    setShowAddExistingExpenseModal(false);
                    resetCheckboxState();
                }}
                selectedExpenseItemIds={selectedExpenseItemIds}
                refetch={refetch}
            />
            <DeleteExpenseModal
                show={showExpenseDeleteModal}
                handleClose={() => setShowExpenseDeleteModal(false)}
                data={expenseDeleteData}
                refetch={refetch} />

            <MergeExpenseModal
                selectedDraftData={showExpenseItemData}
                show={showUpdateExpenseModal}
                handleClose={() => {
                    setShowUpdateExpenseModal(false);
                    resetCheckboxState();
                }}
                refetch={refetch}
            />
            <UnMergeConfirmationModal
                show={showConfirmModal}
                onClose={() => setShowConfirmModal(false)}
                selectedDraftData={selectedItem}
                onSuccess={refetch}
            />
            <PageTitle breadcrumbs={[]}>{labelKey.expenseLineItems}</PageTitle>
            <div className={`card`}>
                {/* begin::Header */}
                <div className='card-header border-0 pt-5'>
                    <div className='d-flex align-items-center'>
                        <SearchBarComponent
                            placeholder='Expense Item'
                            value={immediateSearchStr}
                            onChange={handleSearchChange}
                        />
                        <Tooltip id="refreshData" place="top" />
                        <RefreshComponent onClick={handleRefresh} />
                    </div>
                    <div className='d-md-flex align-items-center'>
                        {/* {isAnyCheckboxChecked && ( */}
                        <div className="d-flex align-items-center gap-2 mt-2 mt-lg-0">
                            <button className={`btn btn-sm btn-light-primary me-3`}
                                onClick={() => {
                                    eidtProjectModalHandler();
                                }}
                                disabled={isAnyCheckboxChecked === false}
                            >
                                <KTSVG path='/media/icons/duotune/arrows/arr075.svg' />
                                {labelKey.addExistingExpense}
                            </button>
                            <button className={`btn btn-sm btn-light-primary me-3`}
                                onClick={() => {
                                    addNewExpenseModalHandler();
                                    setViewOnlyData(false);
                                }}
                                disabled={isAnyCheckboxChecked === false}
                            >
                                <KTSVG path='/media/icons/duotune/arrows/arr075.svg' />
                                {labelKey.addNewExpense}
                            </button>
                        </div>
                        {/* )} */}
                        <div className='d-flex align-items-center gap-2 mt-2 mt-lg-0'>
                            <FilterMenu
                                onclickApplyFilters={applyFilters}
                                onclickResetFilters={resetFilters}
                                isApplyingFiltersLoading={isApplyingFilters}
                            >
                                <>
                                    <TextField
                                        type='number'
                                        label='Item Amount'
                                        placeholder='Search By Amount'
                                        value={localFilterByAmount?.toString() || ""}
                                        onChange={handleFilterByAmount}
                                        fieldClass="mb-5"
                                    />
                                    <SearchSelect
                                        label={`${labelKey.category}:`}
                                        options={[
                                            // { value: '', label: 'All' }, // Add the empty option
                                            ...(Array.isArray(expenseCategory?.result) ? expenseCategory.result.map((option: any) => ({
                                                value: option.id,
                                                label: option?.value,
                                            })) : [])
                                        ]}
                                        placeholder='Select Category'
                                        selectClass='mb-5'
                                        value={localFilterByCategory && localFilterByCategory !== ''
                                            ? {
                                                value: localFilterByCategory,
                                                label: expenseCategory?.result.find((option: any) => option.id === localFilterByCategory)?.value
                                            }
                                            : null
                                        }
                                        onChange={handleCategoryChange}
                                    />
                                    <SearchSelect
                                        label={`${labelKey.paymentMethod}:`}
                                        options={[
                                            // { value: '', label: 'All' }, // Add the empty option
                                            ...(Array.isArray(paymentMethodLookup?.result) ? paymentMethodLookup.result.map((option: any) => ({
                                                value: option.id,
                                                label: option?.value,
                                            })) : [])
                                        ]}
                                        placeholder='Select Payment Method'
                                        selectClass='mb-5'
                                        value={localFilterByPaymentMethodId && localFilterByPaymentMethodId !== 0
                                            ? {
                                                value: localFilterByPaymentMethodId,
                                                label: paymentMethodLookup?.result.find((option: any) => option.id === localFilterByPaymentMethodId)?.value
                                            }
                                            : null
                                        }
                                        onChange={handlePaymentMethodChange}
                                    />
                                    <SearchSelect
                                        label={`${labelKey.source}:`}
                                        options={[
                                            // { value: '', label: 'All' }, // Add the empty option
                                            ...(Array.isArray(recordSourceLookup?.result) ? recordSourceLookup.result.map((option: any) => ({
                                                value: option.id,
                                                label: option?.value,
                                            })) : [])
                                        ]}
                                        placeholder='Select Source'
                                        selectClass='mb-5'
                                        value={localFilterByRecordSourceId && localFilterByRecordSourceId !== 0
                                            ? {
                                                value: localFilterByRecordSourceId,
                                                label: recordSourceLookup?.result.find((option: any) => option.id === localFilterByRecordSourceId)?.value
                                            }
                                            : null
                                        }
                                        onChange={handleRecordSourceChange}
                                    />
                                    <DateRangeComp
                                        label="Item Date Range"
                                        startDate={localFilterByStartDate || moment()}
                                        endDate={localFilterByEndDate || moment()}
                                        onApply={handleDateRangeChange} onCancel={handleCancelDateSelection}
                                        value={localFilterByStartDate && localFilterByEndDate ? `${localFilterByStartDate} - ${localFilterByEndDate}` : "MM/DD/YYYY"}
                                        className="mb-5" />
                                    <DateRangeComp
                                        label="Created Date Range"
                                        startDate={localFilterByCreatedStartDate || moment()}
                                        endDate={localFilterByCreatedEndDate || moment()}
                                        onApply={handleCreatedDateRangeChange} onCancel={handleCreatedCancelDateSelection}
                                        value={localFilterByCreatedStartDate && localFilterByCreatedEndDate ? `${localFilterByCreatedStartDate} - ${localFilterByCreatedEndDate}` : "MM/DD/YYYY"}
                                        className="mb-5" />
                                </>
                            </FilterMenu>
                            <div className='card-toolbar'>
                                <button className='btn btn-sm btn-light-primary'
                                    onClick={() => setShowAddExpenseItemModal(true)}>
                                    <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
                                    {labelKey.addNewItem}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='card-body py-3 pt-1'>
                    <Alert variant="primary" className='w-100 py-2'>
                        <p className='mb-0 fs-6 pt-1'>
                            Corporate Credit Card line items cannot be manually added to the report as it is auto-generated from the Corporate Credit Card Report.
                        </p>
                    </Alert>
                    <div className='table-responsive table-height'>
                        <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                            <thead>
                                <tr className='fw-bold text-muted'>
                                    {hiddenColumns.includes('checkbox') && (
                                        <>
                                            {data?.result?.data?.length > 0 ? (
                                                <TableHeading
                                                    columnId='checkbox'
                                                    className="ps-4"
                                                >
                                                    {/* {data?.result?.data?.ocrPassed && data?.result?.data?.ocrPassed !== false ? ( */}
                                                    <div className='form-check form-check-sm form-check-custom form-check-solid me-3'>
                                                        <input
                                                            type="checkbox"
                                                            className='form-check-input cursor-pointer'
                                                            checked={isTableHeadChecked} onChange={handleTableHeadChange}
                                                        // disabled={data?.ocrPassed === false}
                                                        />
                                                    </div>
                                                    {/* ) : null} */}
                                                </TableHeading>
                                            ) : <th></th>}
                                        </>
                                    )}
                                    {/* {hiddenColumns.includes('sr') && (
                                        <TableHeading
                                            label={labelKey.sr}
                                            columnId='sr'
                                        />
                                    )} */}
                                    {hiddenColumns.includes('itemDate') && (
                                        <TableHeading
                                            label={labelKey.lineItemDate}
                                            sortedColumn={sortedColumn}
                                            sortOrder={sortOrder}
                                            handleSort={handleSort}
                                            columnId='itemDate'
                                        />
                                    )}
                                    {hiddenColumns.includes('expenseType') && (
                                        <TableHeading
                                            label={labelKey.expenseType}
                                            sortedColumn={sortedColumn}
                                            sortOrder={sortOrder}
                                            handleSort={handleSort}
                                            columnId='expenseType'
                                        />
                                    )}
                                    {hiddenColumns.includes('expenseCategory') && (
                                        <TableHeading
                                            label={labelKey.category}
                                            sortedColumn={sortedColumn}
                                            sortOrder={sortOrder}
                                            handleSort={handleSort}
                                            columnId='expenseCategory'
                                        />
                                    )}
                                    {/* {hiddenColumns.includes('currency') && (
                                        <TableHeading
                                            label={labelKey.currency}
                                            sortedColumn={sortedColumn}
                                            sortOrder={sortOrder}
                                            handleSort={handleSort}
                                            columnId='currency'
                                        />
                                    )} */}
                                    {hiddenColumns.includes('amountInOriginalCurrency') && (
                                        <TableHeading
                                            label={labelKey.amountInOrigionalCurrency}
                                            sortedColumn={sortedColumn}
                                            sortOrder={sortOrder}
                                            handleSort={handleSort}
                                            columnId='amountInOriginalCurrency'
                                            labelClassName="text-end"
                                        />
                                    )}

                                    {hiddenColumns.includes('unitPrice') && (
                                        <TableHeading
                                            label={labelKey.unitPrice}
                                            sortedColumn={sortedColumn}
                                            sortOrder={sortOrder}
                                            handleSort={handleSort}
                                            columnId='unitPrice'
                                            labelClassName="text-end"
                                        />
                                    )}


                                    {hiddenColumns.includes('amount') && (
                                        <TableHeading
                                            label={labelKey.amount}
                                            sortedColumn={sortedColumn}
                                            sortOrder={sortOrder}
                                            handleSort={handleSort}
                                            columnId='amount'
                                            labelClassName="text-end"
                                        />
                                    )}
                                    {hiddenColumns.includes('reimbursableDistance') && (
                                        <TableHeading
                                            label={labelKey.reimbursableDistance}
                                            sortedColumn={sortedColumn}
                                            sortOrder={sortOrder}
                                            handleSort={handleSort}
                                            columnId='reimbursableDistance'
                                            labelClassName="justify-content-end text-end"
                                            className="mw-150px text-end"
                                        />
                                    )}
                                    {hiddenColumns.includes('vander') && (
                                        <TableHeading
                                            label={labelKey.vendor}
                                            sortedColumn={sortedColumn}
                                            sortOrder={sortOrder}
                                            handleSort={handleSort}
                                            columnId='vander'
                                        />
                                    )}
                                    {hiddenColumns.includes('paymentMethod') && (
                                        <TableHeading
                                            label={labelKey.paymentMethod}
                                            sortedColumn={sortedColumn}
                                            sortOrder={sortOrder}
                                            handleSort={handleSort}
                                            columnId='paymentMethod'
                                        />
                                    )}

                                    {/* {hiddenColumns.includes('location') && (
                                        <TableHeading
                                            label={labelKey.location}
                                            columnId='location'
                                        />
                                    )} */}
                                    {hiddenColumns.includes('attachment') && (
                                        <TableHeading
                                            label={labelKey.attachment}
                                            columnId='attachment'
                                        />
                                    )}
                                    {hiddenColumns.includes('description') && (
                                        <TableHeading
                                            label={labelKey.description}
                                            columnId='description'
                                            className='w-400px'
                                        />
                                    )}
                                    {hiddenColumns.includes('source') && (
                                        <TableHeading
                                            label={labelKey.source}
                                            columnId='source'
                                        />
                                    )}
                                    {hiddenColumns.includes('createdDateTime') && (
                                        <TableHeading
                                            label={labelKey.createdDate}
                                            sortedColumn={sortedColumn}
                                            sortOrder={sortOrder}
                                            handleSort={handleSort}
                                            columnId='createdDateTime'
                                        />
                                    )}
                                    {hiddenColumns.includes('updatedDate') && (
                                        <TableHeading
                                            label={labelKey.updatedDate}
                                            sortedColumn={sortedColumn}
                                            sortOrder={sortOrder}
                                            handleSort={handleSort}
                                            columnId='updatedDate'
                                        />
                                    )}
                                    {hiddenColumns.includes('createdBy') && (
                                        <TableHeading
                                            label={'createdBy'}
                                            sortedColumn={sortedColumn}
                                            sortOrder={sortOrder}
                                            handleSort={handleSort}
                                            columnId='createdBy'
                                        />
                                    )}

                                    {/* <th>{labelKey.status}</th> */}
                                    <th className='text-end rounded-end pe-2 border-0'>
                                        {hiddenColumns.includes('actions') && (
                                            <>
                                                {labelKey.actions}
                                            </>
                                        )}
                                        <TableSettingMenu>
                                            {data?.result?.data?.length > 0 ? (
                                                <TextField
                                                    rightLabel={labelKey.checkbox}
                                                    type="checkbox"
                                                    onChange={() => handleToggleColumn("checkbox")}
                                                    checked={hiddenColumns.includes('checkbox')}
                                                    fieldClass='mb-4'
                                                />)
                                                : null
                                            }
                                            {/* <TextField
                                                rightLabel={labelKey.sr}
                                                type="checkbox"
                                                onChange={() => handleToggleColumn("sr")}
                                                checked={hiddenColumns.includes('sr')}
                                                fieldClass='mb-4'
                                            /> */}
                                            <TextField
                                                rightLabel={labelKey.lineItemDate}
                                                type="checkbox"
                                                onChange={() => handleToggleColumn("itemDate")}
                                                checked={hiddenColumns.includes('itemDate')}
                                                fieldClass='mb-4'
                                            />
                                            <TextField
                                                rightLabel={labelKey.expenseType}
                                                type="checkbox"
                                                onChange={() => handleToggleColumn("expenseType")}
                                                checked={hiddenColumns.includes('expenseType')}
                                                fieldClass='mb-4'
                                            />
                                            <TextField
                                                rightLabel={labelKey.category}
                                                type="checkbox"
                                                onChange={() => handleToggleColumn("expenseCategory")}
                                                checked={hiddenColumns.includes('expenseCategory')}
                                                fieldClass='mb-4'
                                            />
                                            {/* <TextField
                                                rightLabel={labelKey.currency}
                                                type="checkbox"
                                                onChange={() => handleToggleColumn("currency")}
                                                checked={hiddenColumns.includes('currency')}
                                                fieldClass='mb-4'
                                            /> */}

                                            <TextField
                                                rightLabel={labelKey.amountInOrigionalCurrency}
                                                type="checkbox"
                                                onChange={() => handleToggleColumn("amountInOriginalCurrency")}
                                                checked={hiddenColumns.includes('amountInOriginalCurrency')}
                                                fieldClass='mb-4'
                                            />
                                            <TextField
                                                rightLabel={labelKey.unitPrice}
                                                type="checkbox"
                                                onChange={() => handleToggleColumn("unitPrice")}
                                                checked={hiddenColumns.includes('unitPrice')}
                                                fieldClass='mb-4'
                                            />

                                            <TextField
                                                rightLabel={labelKey.amount}
                                                type="checkbox"
                                                onChange={() => handleToggleColumn("amount")}
                                                checked={hiddenColumns.includes('amount')}
                                                fieldClass='mb-4'
                                            />
                                            <TextField
                                                rightLabel={labelKey.reimbursableDistance}
                                                type="checkbox"
                                                onChange={() => handleToggleColumn("reimbursableDistance")}
                                                checked={hiddenColumns.includes('reimbursableDistance')}
                                                fieldClass='mb-4'
                                            />
                                            <TextField
                                                rightLabel={labelKey.vendor}
                                                type="checkbox"
                                                onChange={() => handleToggleColumn("vander")}
                                                checked={hiddenColumns.includes('vander')}
                                                fieldClass='mb-4'
                                            />
                                            <TextField
                                                rightLabel={labelKey.paymentMethod}
                                                type="checkbox"
                                                onChange={() => handleToggleColumn("paymentMethod")}
                                                checked={hiddenColumns.includes('paymentMethod')}
                                                fieldClass='mb-4'
                                            />

                                            {/* <TextField
                                                rightLabel={labelKey.location}
                                                type="checkbox"
                                                onChange={() => handleToggleColumn("location")}
                                                checked={hiddenColumns.includes('location')}
                                                fieldClass='mb-4'
                                            /> */}
                                            <TextField
                                                rightLabel={labelKey.attachment}
                                                type="checkbox"
                                                onChange={() => handleToggleColumn("attachment")}
                                                checked={hiddenColumns.includes('attachment')}
                                                fieldClass='mb-4'
                                            />
                                            <TextField
                                                rightLabel={labelKey.description}
                                                type="checkbox"
                                                onChange={() => handleToggleColumn("description")}
                                                checked={hiddenColumns.includes('description')}
                                                fieldClass='mb-4'
                                            />
                                            <TextField
                                                rightLabel={labelKey.source}
                                                type="checkbox"
                                                onChange={() => handleToggleColumn("source")}
                                                checked={hiddenColumns.includes('source')}
                                                fieldClass='mb-4'
                                            />
                                            <TextField
                                                rightLabel={labelKey.createdDate}
                                                type="checkbox"
                                                onChange={() => handleToggleColumn("createdDateTime")}
                                                checked={hiddenColumns.includes('createdDateTime')}
                                                fieldClass='mb-4'
                                            />
                                            <TextField
                                                rightLabel={labelKey.updatedDate}
                                                type="checkbox"
                                                onChange={() => handleToggleColumn("updatedDate")}
                                                checked={hiddenColumns.includes('updatedDate')}
                                                fieldClass='mb-4'
                                            />
                                            <TextField
                                                rightLabel={'createdBy'}
                                                type="checkbox"
                                                onChange={() => handleToggleColumn("createdBy")}
                                                checked={hiddenColumns.includes('createdBy')}
                                                fieldClass='mb-4'
                                            />
                                            <TextField
                                                rightLabel={labelKey.actions}
                                                type="checkbox"
                                                onChange={() => handleToggleColumn("actions")}
                                                checked={hiddenColumns.includes('actions')}
                                                fieldClass='mb-4'
                                            />
                                        </TableSettingMenu>
                                    </th>

                                </tr>
                            </thead>
                            <tbody>
                                {!isLoading &&
                                    <>
                                        {data?.result?.data?.length > 0 ? (
                                            <>
                                                {data?.result?.data?.map((data: any, index: any) => (
                                                    <tr
                                                        key={data?.expenseItemId}
                                                        className={`${selectedExpenseItemIds.includes(data.expenseItemId) ? 'highlighted-row' : ''}`}>
                                                        {hiddenColumns.includes('checkbox') && (
                                                            <td className='ps-4'>
                                                                {data?.recordSourceId !== constraintConfig.recordSourceId.BankFeed &&
                                                                    <TextField
                                                                        type="checkbox"
                                                                        fieldClass='form-check-input cursor-pointer'
                                                                        checked={isTableHeadChecked || selectedExpenseItemIds.includes(data.expenseItemId)}
                                                                        onChange={(e) => handleCheckItem(e, data.expenseItemId)}
                                                                        disabled={data?.recordSourceId === constraintConfig.recordSourceId.BankFeed}
                                                                    // disabled={data?.ocrPassed === false}
                                                                    />
                                                                }
                                                            </td>
                                                        )}
                                                        {/* {hiddenColumns.includes('sr') && (
                                                            <td>
                                                                {(page - 1) * pageSize + index + 1}
                                                            </td>
                                                        )} */}
                                                        {hiddenColumns.includes('itemDate') && (
                                                            <td><DateComp formattedDate={data.itemDate} /></td>
                                                        )}
                                                        {hiddenColumns.includes('expenseType') && (
                                                            <td className='ps-5'>{data?.expenseType?.title}</td>
                                                        )}
                                                        {hiddenColumns.includes('expenseCategory') && (
                                                            <td className='ps-5'><CategoriesWithIcons itemData={data} /></td>
                                                        )}
                                                        {hiddenColumns.includes('amountInOriginalCurrency') && (
                                                            <td className='ps-5'>{data?.amountInOrigionalCurrency}</td>
                                                        )}
                                                        {hiddenColumns.includes('unitPrice') && (
                                                            <td className='ps-5'>{data?.unitPrice}</td>
                                                        )}

                                                        {/* {hiddenColumns.includes('currency') && (
                                                            <td className='ps-10'>{data?.currency?.title}</td>
                                                        )} */}
                                                        {hiddenColumns.includes('amount') && (
                                                            <td className={`text-end ${data?.debitOrCreditIndicator === constraintConfig.debitOrCreditIndicator.creditIndicator ? 'text-danger' : null}`}>
                                                                <CurrencyComp amount={data?.amount} />
                                                            </td>
                                                        )}
                                                        {hiddenColumns.includes('reimbursableDistance') && (
                                                            <td className='text-end'>
                                                                {data?.expenseCategory?.id === constraintConfig.categoriesId.mileage ?
                                                                    <>
                                                                        {data?.reimbursableDistance}
                                                                    </>
                                                                    : null
                                                                }
                                                            </td>
                                                        )}
                                                        {hiddenColumns.includes('vander') && (
                                                            <td>{data?.vendor?.name !== " " ? data?.vendor?.name : "N/A"}</td>
                                                        )}
                                                        {hiddenColumns.includes('paymentMethod') && (
                                                            <td>{data?.paymentMethod?.title}</td>
                                                        )}

                                                        {/* {hiddenColumns.includes('location') && (
                                                            <td>{data?.expItemLocation?.title ? data?.expItemLocation?.title : "N/A"}</td>
                                                        )} */}
                                                        {hiddenColumns.includes('attachment') && (
                                                            <td>
                                                                <Tooltip id="upload-reciept" place="top" />
                                                                {/* {data?.expenseCategory?.id === constraintConfig.categoriesId.mileage ? '' :
                                                                    data?.attachmentFile === null || data?.attachmentFile === "null" || data?.attachmentFile === "undefined" || data?.attachmentFile === "" || data?.attachmentFile === "Receipt is not available" ? (
                                                                        data?.debitOrCreditIndicator === constraintConfig.debitOrCreditIndicator.creditIndicator ? null : (

                                                                            <div className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm ms-7'
                                                                                data-tooltip-id="upload-reciept" data-tooltip-content='Upload Reciept'
                                                                                onClick={() => setShowExpenseItemData(data)}
                                                                            >
                                                                                <UploadDirectReceipt data={showExpenseItemData} refetch={refetch} />
                                                                            </div>)
                                                                    ) :

                                                                        <FaEye className='ms-10' onClick={() => openPdfInBrowserOrLightbox(data?.attachmentFile)} />
                                                                } */}
                                                                {data?.attachmentFile === null ||
                                                                    data?.attachmentFile === "null" ||
                                                                    data?.attachmentFile === "undefined" ||
                                                                    data?.attachmentFile === "" ||
                                                                    data?.attachmentFile === "Receipt is not available" ? (
                                                                    data?.debitOrCreditIndicator === constraintConfig.debitOrCreditIndicator.creditIndicator ? null : (
                                                                        <div
                                                                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm ms-7'
                                                                            data-tooltip-id="upload-reciept"
                                                                            data-tooltip-content='Upload Receipt'
                                                                            onClick={() => setShowExpenseItemData(data)}
                                                                        >
                                                                            <UploadDirectReceipt data={showExpenseItemData} refetch={refetch} />
                                                                        </div>
                                                                    )
                                                                )
                                                                    : (
                                                                        <FaEye className='ms-10' onClick={() => openPdfInBrowserOrLightbox(data?.attachmentFile)} />
                                                                    )}

                                                                {lightboxOpen && (
                                                                    <Lightbox
                                                                        mainSrc={lightboxData.imageURL}
                                                                        onCloseRequest={() => setLightboxOpen(false)}
                                                                        imageCaption="Attachment"
                                                                        enableZoom={true}
                                                                        imagePadding={50}
                                                                    />
                                                                )}
                                                            </td>
                                                        )}
                                                        {/* <td>
                                                            {data?.ocrPassed === true ?
                                                                <span className="badge badge-light-success fs-7 fw-semibold">Passed</span> :
                                                                <span className="badge badge-light-danger fs-7 fw-semibold">Failed</span>
                                                            }
                                                        </td> */}
                                                        {hiddenColumns.includes('description') && (
                                                            <td className='text-wrap'>
                                                                {/* {data?.itemDetail?.length > 60 ? `${data?.itemDetail.substring(0, 40)}...` : data?.itemDetail} */}
                                                                {data && data.itemDetail && <ReactReadMoreReadLess
                                                                    charLimit={30}
                                                                    readMoreText={"Read more"}
                                                                    readLessText={"Read less"}
                                                                    readMoreClassName="readMore"
                                                                    readLessClassName="readLess"
                                                                >
                                                                    {data.itemDetail}
                                                                </ReactReadMoreReadLess>}
                                                            </td>
                                                        )}
                                                        {hiddenColumns.includes('source') && (
                                                            <td>
                                                                <Tooltip id="web-source" place="top" />
                                                                <Tooltip id="mobile-source" place="top" />
                                                                <Tooltip id="bank-source" place="top" />
                                                                <Tooltip id="gorilla-source" place="top" />

                                                                {data?.recordSourceId === constraintConfig.recordSourceId.WebApp ?
                                                                    <KTSVG path="/media/icons/figmaIcons/Web.svg" className='svg-icon-1 ms-4'
                                                                        data-tooltip-id="web-source" data-tooltip-content='Website' />
                                                                    :
                                                                    data?.recordSourceId === constraintConfig.recordSourceId.Mobile ?
                                                                        <KTSVG path="/media/icons/figmaIcons/Mobile.svg" className='svg-icon-1 ms-4'
                                                                            data-tooltip-id="mobile-source" data-tooltip-content='Mobile' /> :
                                                                        data?.recordSourceId === constraintConfig.recordSourceId.BankFeed ?
                                                                            <KTSVG path="/media/icons/figmaIcons/Bank.svg" className='svg-icon-1 ms-4'
                                                                                data-tooltip-id="bank-source" data-tooltip-content='Bank' />
                                                                            : data?.recordSourceId === constraintConfig.recordSourceId.GorillaExpense ?
                                                                                <KTSVG path="/media/icons/figmaIcons/Gorilla.svg" className='svg-icon-1 ms-4'
                                                                                    data-tooltip-id="gorilla-source" data-tooltip-content='Gorilla Expense' /> : null}
                                                            </td>
                                                        )}
                                                        {hiddenColumns.includes('createdDateTime') && (
                                                            <td><DateTimeComp formattedDate={data.createdDate} /></td>
                                                        )}
                                                        {hiddenColumns.includes('updatedDate') && (
                                                            <td><DateTimeComp formattedDate={data.updatedDate} /></td>
                                                        )}

                                                        {hiddenColumns.includes('createdBy') && (
                                                            <td>

                                                                {data?.onBehalfOfUser?.firstName &&
                                                                    <div className='d-flex align-items-center'>
                                                                        <div className='symbol symbol-40px symbol-circle me-3'>
                                                                            {/* {data?.manager?.imageUrl ? <img src={data?.manager?.imageUrl} alt="" /> : */}
                                                                            <div className="symbol-label fs-3 bg-light-info text-info text-capitalize">{data?.onBehalfOfUser?.firstName?.charAt(0)}</div>
                                                                            {/* } */}
                                                                        </div>
                                                                        <div className='d-flex justify-content-start flex-column'>
                                                                            <p className='text-capitalize mb-0'>
                                                                                {data?.onBehalfOfUser?.firstName}  {data?.onBehalfOfUser?.lastName}
                                                                            </p>
                                                                            <span className='text-muted fw-semibold text-muted text-lowercase d-block fs-7'>
                                                                                {data?.onBehalfOfUser?.email}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                }

                                                            </td>
                                                        )}
                                                        {hiddenColumns.includes('actions') && (
                                                            <td>
                                                                <div className='d-flex align-items-center justify-content-end gap-2 pe-2' >
                                                                    <Tooltip id="Update-Item" place="top" />
                                                                    <Tooltip id="Delete-Item" place="top" />
                                                                    <Tooltip id="Detail-Item" place="top" />
                                                                    <Tooltip id="Merge-item" place="top" />
                                                                    <Tooltip id="Un-Merge-item" place="top" />
                                                                    {/* -------------------- Merge and Un merge Expense ----------------- */}
                                                                    {data?.mergeExpenseitemId > 0 &&
                                                                        data?.recordSourceId === constraintConfig.recordSourceId.BankFeed &&
                                                                        data?.paymentMethod?.id === constraintConfig.paymentMethod.corporateCreditCard && (
                                                                            <div
                                                                                data-tooltip-id="Un-Merge-item"
                                                                                data-tooltip-content="Un-Merge Expense"
                                                                                className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm"
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation(); // prevent bubbling
                                                                                    handleUnmergeClick(data);
                                                                                }}
                                                                            >
                                                                                <KTSVG
                                                                                    path="/media/icons/duotune/general/unmerge.svg"
                                                                                    className="svg-icon-3"
                                                                                />
                                                                            </div>
                                                                        )}

                                                                    {(
                                                                        data?.recordSourceId !== constraintConfig.recordSourceId.BankFeed &&
                                                                        data?.paymentMethod?.id !== constraintConfig.paymentMethod.corporateCreditCard) && (
                                                                            <div
                                                                                data-tooltip-id="Merge-item"
                                                                                data-tooltip-content="Merge Expense"
                                                                                className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
                                                                                onClick={() => {
                                                                                    setShowExpenseItemData(data)
                                                                                    setShowUpdateExpenseModal(true)
                                                                                }}
                                                                            >
                                                                                <KTSVG
                                                                                    path="/media/icons/duotune/general/merge.svg"
                                                                                    className="svg-icon-3"
                                                                                />
                                                                            </div>
                                                                        )}


                                                                    {/* {constraintConfig.paymentMethod.corporateCreditCard !== data?.paymentMethod?.id &&
                                                                        data?.recordSourceId !== constraintConfig.recordSourceId.BankFeed && (
                                                                            data?.mergeExpenseitemId > 0 ? (

                                                                                <div
                                                                                    data-tooltip-id="Un-Merge-item"
                                                                                    data-tooltip-content="Un-Merge Expense"
                                                                                    className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm"
                                                                                    onClick={() => {
                                                                                        setShowExpenseItemData(data)
                                                                                    }}
                                                                                >
                                                                                    <KTSVG
                                                                                        path="/media/icons/duotune/general/unmerge.svg"
                                                                                        className="svg-icon-3"
                                                                                    />
                                                                                </div>
                                                                            ) : (
                                                                                <div
                                                                                    data-tooltip-id="Merge-item"
                                                                                    data-tooltip-content="Merge Expense"
                                                                                    className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
                                                                                    onClick={() => {
                                                                                        setShowExpenseItemData(data)
                                                                                        setShowUpdateExpenseModal(true)
                                                                                    }}
                                                                                >
                                                                                    <KTSVG
                                                                                        path="/media/icons/duotune/general/merge.svg"
                                                                                        className="svg-icon-3"
                                                                                    />
                                                                                </div>
                                                                            )
                                                                        )} */}



                                                                    {/* -------------------- Merge and Un merge Expense ----------------- */}

                                                                    {constraintConfig.paymentMethod.corporateCreditCard !== data?.paymentMethod?.id &&
                                                                        data?.recordSourceId !== constraintConfig.recordSourceId.BankFeed ?
                                                                        <div
                                                                            data-tooltip-id="Delete-Item" data-tooltip-content='Delete Expense'
                                                                            className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm'

                                                                            onClick={() => {
                                                                                setExpenseDeleteData(data?.expenseItemId);
                                                                                deleteHandler();
                                                                            }}
                                                                        >
                                                                            <KTSVG path='/media/icons/duotune/general/gen027.svg' className='svg-icon-3 text-hover-danger' svgClassName='svg-danger' />
                                                                        </div>
                                                                        : null}
                                                                    {data?.debitOrCreditIndicator !== constraintConfig.debitOrCreditIndicator.creditIndicator &&
                                                                        <div
                                                                            data-tooltip-id="Update-Item" data-tooltip-content='Update Item'
                                                                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                                                            onClick={() => {
                                                                                expenseItemById({ expenseItemId: data?.expenseItemId })
                                                                                setViewOnlyData(false)
                                                                                setShowExpenseItemData(data);
                                                                                expenseItemModalHandler();
                                                                            }}
                                                                        >
                                                                            <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' />
                                                                        </div>
                                                                    }
                                                                    <div
                                                                        data-tooltip-id="Detail-Item" data-tooltip-content='Item Detail'
                                                                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                                                        onClick={() => {
                                                                            expenseItemById({ expenseItemId: data?.expenseItemId })
                                                                            setViewOnlyData(true)
                                                                            setShowExpenseItemData(data);
                                                                            // expenseItemModalHandler();
                                                                            setShowExpenseItemDetailModal(true)

                                                                        }}
                                                                    >
                                                                        <KTSVG path='/media/icons/duotune/arrows/arr064.svg' className='svg-icon-3' />
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        )}
                                                    </tr>
                                                ))}
                                            </>
                                        ) :
                                            (
                                                <tr>
                                                    <td colSpan={15}>
                                                        <NoRecordFound />
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    </>
                                }
                                {isLoading && (
                                    <tr>
                                        <td colSpan={15} className="text-center">
                                            <LoadingComponent />
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table >
                    </div >
                    <Pagination
                        totalResult={data?.result?.totalRecords === 0 ? 0 : ((data?.result?.pageNumber - 1) * data?.result?.pageSize) + 1}
                        toResult={data?.result?.totalRecords === 0 ? 0 : Math.min(data?.result?.pageNumber * data?.result?.pageSize, data?.result?.totalRecords)}
                        ofResult={data?.result?.totalRecords}
                        onChange={handlePageSizeChange}
                        pageSize={pageSize}
                        onPageChange={handlePageClick}
                        pageCount={data?.result?.totalPages || 0}
                        currentPage={page}
                    />
                    {/* end::Table container */}
                </div >


                {/* begin::Body */}
            </div >
        </>
    )
}

export default DraftItemsPage